import { Repository } from "./repository";
import { Session } from "./session";
import { Storage } from "./storage";

export abstract class BLoC {
  protected repository?: Repository;
  protected storage?: Storage;
  protected session?: Session;
}
